import { useSettings } from '../context/SettingsContext';
import { getTemplateLabel } from '../utils/templateUtils';
import { useTranslation } from 'react-i18next';

export const useTemplate = () => {
    const { settings } = useSettings();
    const { t } = useTranslation();
    const template = settings?.system_template || 'school';

    const getLabel = (key, fallbackKey) => {
        const templateLabel = getTemplateLabel(template, key);
        if (templateLabel) return templateLabel;
        return fallbackKey ? t(fallbackKey) : key;
    };

    return {
        template,
        getLabel,
        // Helper properties for common labels
        studentLabel: getTemplateLabel(template, 'student'),
        studentsLabel: getTemplateLabel(template, 'students'),
        classLabel: getTemplateLabel(template, 'class'),
        classesLabel: getTemplateLabel(template, 'classes'),
        teacherLabel: getTemplateLabel(template, 'teacher'),
        teachersLabel: getTemplateLabel(template, 'teachers'),
        marksLabel: getTemplateLabel(template, 'marks'),
        examsLabel: getTemplateLabel(template, 'exams'),
    };
};
